const titleAndLink = {
  support: [
    ["Help Center", "https://www.airbnb.com.vn/help/home?from=footer"],
    ["AirCover", "https://www.airbnb.com.vn/help/article/3218"],
    ["Combating discrimination", "https://www.airbnb.com.vn/guest/inbox/1607671003"],
    ["Supporting people with disabilities", "https://www.airbnb.com.vn/accessibility"],
    ["Cancellation options", "https://www.airbnb.com.vn/help/article/2701"],
    ["Report neighborhood concern", "https://www.airbnb.com.vn/help/article/3290"],
  ],
  community: [
    ["Airbnb.org: disaster relief housing", "https://www.airbnb.com.vn/host/homes?from_footer=1"],
    ["Combating discrimination", "https://www.airbnb.com.vn/aircover-for-hosts"],
  ],
  hosting: [
    ['Airbnb your home','https://www.airbnb.com.vn/resources/hosting-homes'],
    ['AirCover for Hosts','https://www.airbnb.com.vn/help/topic/1442'],
    ['Hosting resources','https://www.airbnb.com.vn/help/article/1319'],
    ['Community forum','https://community.withairbnb.com/t5/Community-Center/ct-p/community-center'],
    ['Hosting responsibly','https://www.airbnb.com.vn/help/article/1397'],
    ['Airbnb-friendly apartments',''],
  ],
  airbnb: [
    ['Newsroom','https://news.airbnb.com/'],
    ['New features','https://www.airbnb.com.vn/release'],
    ['Careers','https://careers.airbnb.com/'],
    ['Investors','https://investors.airbnb.com/home/default.aspx'],
    ['Gift cards','https://vi.airbnb.org/?_set_bev_on_new_domain=1695387949_NGRlZjU1NzVkNGU5'],
    ['Airbnb.org disater relief','https://www.airbnb.com.vn/help/article/1397'],
  ]
  
};

export default titleAndLink
